module.exports = __webpack_public_path__ + "static/media/cardIcon.863c8a60.svg";